import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {tryParsePublicId} from '../../../models/applications/publicIdTypes';
import {AppState} from '../../../store/appState';
import {makeGetInbox} from '../../../store/data/inboxes/inboxesSelectors';
import {InboxPopover} from './inboxPopover';

/*
 * Props.
 */

interface InboxPopoverContainerProps {
  inboxPublicId: string;
}

/*
 * Selectors.
 */

function getInboxId(_state: AppState, props: InboxPopoverContainerProps) {
  return tryParsePublicId(props.inboxPublicId, 'inbox');
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InboxPopoverContainerProps>()(() => ({
  inbox: makeGetInbox(getInboxId),
}));

export const InboxPopoverContainer = connect(mapStateToProps)(InboxPopover);
